import script from "./TestVendorList.vue?vue&type=script&setup=true&lang=js"
export * from "./TestVendorList.vue?vue&type=script&setup=true&lang=js"

import "./TestVendorList.vue?vue&type=style&index=0&id=218a29ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218a29ee"]])

export default __exports__